import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalModule } from '../modal/modal.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { FiltersComponent } from './filters.component';
import { ButtonModule } from '../buttons/button.module';
import { IconsModule } from '../icons/icons.module';
import { ClickOutsideDirectiveModule } from '../../directives/click-outside/click-outside-directive.module';
import { PopoverModule } from '../popover/popover.module';

@NgModule({
  declarations: [FiltersComponent],
  imports: [
    CommonModule,
    IconsModule,
    ButtonModule,
    ClickOutsideDirectiveModule,
    PopoverModule,
    ModalModule,
    NotificationsModule,
  ],
  exports: [FiltersComponent],
  providers: [],
})
export class FiltersModule {}
